<ngx-skeleton-loader
    appearance="circle"
    [animation]="animation" 
    [count]="count"
    [theme]="theme"
></ngx-skeleton-loader>
